import { dashboardStateActions } from '.';

export const { setColors, setEmail, setOverview, setOpenMenu, closeMenu } = dashboardStateActions;
